import { render, staticRenderFns } from "./TestOrderList.vue?vue&type=template&id=1b888d8f&scoped=true"
import script from "./TestOrderList.vue?vue&type=script&lang=js"
export * from "./TestOrderList.vue?vue&type=script&lang=js"
import style0 from "./TestOrderList.vue?vue&type=style&index=0&id=1b888d8f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b888d8f",
  null
  
)

export default component.exports